module.exports = __webpack_public_path__ + "html/nav-drawer.template.html";